import axios from 'axios';

export function get({url}){
    return axios.get(url)
}

export function post({url, data}){
    return axios({
        method: 'post',
        url,data
      });
}

